/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type {
  IBosonExchangeHandler,
  IBosonExchangeHandlerInterface,
} from "../IBosonExchangeHandler";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "offerId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "buyerId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "exchangeId",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "offerId",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "buyerId",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "finalizedDate",
            type: "uint256",
          },
          {
            internalType: "enum BosonTypes.ExchangeState",
            name: "state",
            type: "uint8",
          },
        ],
        indexed: false,
        internalType: "struct BosonTypes.Exchange",
        name: "exchange",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "committedDate",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "validUntilDate",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "redeemedDate",
            type: "uint256",
          },
          {
            internalType: "bool",
            name: "expired",
            type: "bool",
          },
        ],
        indexed: false,
        internalType: "struct BosonTypes.Voucher",
        name: "voucher",
        type: "tuple",
      },
      {
        indexed: false,
        internalType: "address",
        name: "executedBy",
        type: "address",
      },
    ],
    name: "BuyerCommitted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "offerId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "buyerId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "exchangeId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "executedBy",
        type: "address",
      },
    ],
    name: "ExchangeCompleted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "entityId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "exchangeToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "executedBy",
        type: "address",
      },
    ],
    name: "FundsEncumbered",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "exchangeId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "entityId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "exchangeToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "executedBy",
        type: "address",
      },
    ],
    name: "FundsReleased",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "sellerId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "withdrawnTo",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "tokenAddress",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "executedBy",
        type: "address",
      },
    ],
    name: "FundsWithdrawn",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "exchangeId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "exchangeToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "executedBy",
        type: "address",
      },
    ],
    name: "ProtocolFeeCollected",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "twinId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "sellerId",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "sellerId",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "supplyAvailable",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "tokenId",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "tokenAddress",
            type: "address",
          },
          {
            internalType: "enum BosonTypes.TokenType",
            name: "tokenType",
            type: "uint8",
          },
        ],
        indexed: false,
        internalType: "struct BosonTypes.Twin",
        name: "twin",
        type: "tuple",
      },
      {
        indexed: true,
        internalType: "address",
        name: "executedBy",
        type: "address",
      },
    ],
    name: "TwinCreated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "twinId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "sellerId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "executedBy",
        type: "address",
      },
    ],
    name: "TwinDeleted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "twinId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "tokenAddress",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "exchangeId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "executedBy",
        type: "address",
      },
    ],
    name: "TwinTransferFailed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "twinId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "tokenAddress",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "exchangeId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "executedBy",
        type: "address",
      },
    ],
    name: "TwinTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "offerId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "exchangeId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "executedBy",
        type: "address",
      },
    ],
    name: "VoucherCanceled",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "offerId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "exchangeId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "executedBy",
        type: "address",
      },
    ],
    name: "VoucherExpired",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "offerId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "exchangeId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "validUntil",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "executedBy",
        type: "address",
      },
    ],
    name: "VoucherExtended",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "offerId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "exchangeId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "executedBy",
        type: "address",
      },
    ],
    name: "VoucherRedeemed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "offerId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "exchangeId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "executedBy",
        type: "address",
      },
    ],
    name: "VoucherRevoked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "offerId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "exchangeId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "newBuyerId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "executedBy",
        type: "address",
      },
    ],
    name: "VoucherTransferred",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_exchangeId",
        type: "uint256",
      },
    ],
    name: "cancelVoucher",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address payable",
        name: "_buyer",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_offerId",
        type: "uint256",
      },
    ],
    name: "commitToOffer",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address payable",
        name: "_buyer",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_offerId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_exchangeId",
        type: "uint256",
      },
    ],
    name: "commitToPreMintedOffer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_exchangeId",
        type: "uint256",
      },
    ],
    name: "completeExchange",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "_exchangeIds",
        type: "uint256[]",
      },
    ],
    name: "completeExchangeBatch",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_exchangeId",
        type: "uint256",
      },
    ],
    name: "expireVoucher",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_exchangeId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_validUntilDate",
        type: "uint256",
      },
    ],
    name: "extendVoucher",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_exchangeId",
        type: "uint256",
      },
    ],
    name: "getExchange",
    outputs: [
      {
        internalType: "bool",
        name: "exists",
        type: "bool",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "offerId",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "buyerId",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "finalizedDate",
            type: "uint256",
          },
          {
            internalType: "enum BosonTypes.ExchangeState",
            name: "state",
            type: "uint8",
          },
        ],
        internalType: "struct BosonTypes.Exchange",
        name: "exchange",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "committedDate",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "validUntilDate",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "redeemedDate",
            type: "uint256",
          },
          {
            internalType: "bool",
            name: "expired",
            type: "bool",
          },
        ],
        internalType: "struct BosonTypes.Voucher",
        name: "voucher",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_exchangeId",
        type: "uint256",
      },
    ],
    name: "getExchangeState",
    outputs: [
      {
        internalType: "bool",
        name: "exists",
        type: "bool",
      },
      {
        internalType: "enum BosonTypes.ExchangeState",
        name: "state",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getNextExchangeId",
    outputs: [
      {
        internalType: "uint256",
        name: "nextExchangeId",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_exchangeId",
        type: "uint256",
      },
    ],
    name: "getReceipt",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "exchangeId",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "offerId",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "buyerId",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "sellerId",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "price",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "sellerDeposit",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "buyerCancelPenalty",
            type: "uint256",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "protocolFee",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "agentFee",
                type: "uint256",
              },
            ],
            internalType: "struct BosonTypes.OfferFees",
            name: "offerFees",
            type: "tuple",
          },
          {
            internalType: "uint256",
            name: "agentId",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "exchangeToken",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "finalizedDate",
            type: "uint256",
          },
          {
            components: [
              {
                internalType: "enum BosonTypes.EvaluationMethod",
                name: "method",
                type: "uint8",
              },
              {
                internalType: "enum BosonTypes.TokenType",
                name: "tokenType",
                type: "uint8",
              },
              {
                internalType: "address",
                name: "tokenAddress",
                type: "address",
              },
              {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "threshold",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "maxCommits",
                type: "uint256",
              },
            ],
            internalType: "struct BosonTypes.Condition",
            name: "condition",
            type: "tuple",
          },
          {
            internalType: "uint256",
            name: "committedDate",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "redeemedDate",
            type: "uint256",
          },
          {
            internalType: "bool",
            name: "voucherExpired",
            type: "bool",
          },
          {
            internalType: "uint256",
            name: "disputeResolverId",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "disputedDate",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "escalatedDate",
            type: "uint256",
          },
          {
            internalType: "enum BosonTypes.DisputeState",
            name: "disputeState",
            type: "uint8",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "twinId",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
              },
              {
                internalType: "address",
                name: "tokenAddress",
                type: "address",
              },
              {
                internalType: "enum BosonTypes.TokenType",
                name: "tokenType",
                type: "uint8",
              },
            ],
            internalType: "struct BosonTypes.TwinReceipt[]",
            name: "twinReceipts",
            type: "tuple[]",
          },
        ],
        internalType: "struct BosonTypes.Receipt",
        name: "receipt",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_exchangeId",
        type: "uint256",
      },
    ],
    name: "isExchangeFinalized",
    outputs: [
      {
        internalType: "bool",
        name: "exists",
        type: "bool",
      },
      {
        internalType: "bool",
        name: "isFinalized",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_exchangeId",
        type: "uint256",
      },
      {
        internalType: "address payable",
        name: "_newBuyer",
        type: "address",
      },
    ],
    name: "onVoucherTransferred",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_exchangeId",
        type: "uint256",
      },
    ],
    name: "redeemVoucher",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_exchangeId",
        type: "uint256",
      },
    ],
    name: "revokeVoucher",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

export class IBosonExchangeHandler__factory {
  static readonly abi = _abi;
  static createInterface(): IBosonExchangeHandlerInterface {
    return new utils.Interface(_abi) as IBosonExchangeHandlerInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): IBosonExchangeHandler {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as IBosonExchangeHandler;
  }
}
